import Paper from "@material-ui/core/Paper";
import Styled from "styled-components";
import { fontSize, color, spacingDefaults } from "style/constants";

export const StyledModalPaper = Styled(Paper)`
  width: 70%;
  min-width: 600px;
  max-width: 800px;
  margin: 4rem auto;

  h2 {
    margin: 0;
    font-weight: normal;
  }
  .assessment {
    color: ${color.LIGHTGRAY};
    font-size: ${fontSize.xsmall};
    font-weight: 500;
    letter-spacing: 1.5px;
    margin-bottom: 0;
    margin-top: ${spacingDefaults.xsmall};
    text-transform: uppercase;
  }
  .user {
    font-size: ${fontSize.large};
    font-weight: normal;
    margin-top: 0;
  }
  .modal-title {
    border-bottom: solid 1px ${color.GRAY};
    padding: 1rem;
  }
  .modal-content {
    padding: 1rem 2rem;
  }
  .secondary-text {
    color: ${color.DARKERGRAY};
  }
`;
